// extracted by mini-css-extract-plugin
export default {"rideOrderPage":"RideOrderPage_rideOrderPage__OOIuc","mapLayer":"RideOrderPage_mapLayer__onYZZ","formCard":"RideOrderPage_formCard__8iPYR"};